require.register("resources/assets/coffee/Core/CancelDialog", function(exports, require, module){
  $0
  
});

